import React, { memo, ReactElement } from "react";
import { UX4_PRIMARY_ORANGE } from "@cart-ui/constants/Color";

function HomeAddressIconv4(): ReactElement {
    return (
        <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.18301 1.1766C10.0636 0.589467 10.5038 0.295898 10.9996 0.295898C11.4954 0.295898 11.9357 0.589467 12.8163 1.1766L15.9635 3.27513C19.6363 5.72413 21.4728 6.94863 21.1207 8.11139C20.9204 8.77266 20.1202 9.05786 18.6552 9.18087V13.9014C18.6552 16.2313 18.6552 17.3963 17.9314 18.1201C17.2076 18.844 16.0426 18.844 13.7126 18.844H13.4452V13.7238C13.4452 12.8382 13.4452 12.3953 13.1701 12.1202C12.8949 11.8451 12.4521 11.8451 11.5665 11.8451H10.4321C9.54651 11.8451 9.10369 11.8451 8.82856 12.1202C8.55343 12.3953 8.55343 12.8382 8.55343 13.7238V18.844H8.28616C5.95619 18.844 4.79121 18.844 4.06738 18.1201C3.34355 17.3963 3.34355 16.2313 3.34355 13.9014V9.18083C1.8789 9.05779 1.07883 8.77258 0.87861 8.11139C0.526502 6.94863 2.36293 5.72413 6.03578 3.27513L9.18301 1.1766Z"
                fill={UX4_PRIMARY_ORANGE}
            />
        </svg>
    );
}

export default memo(HomeAddressIconv4);
